/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'

import Menu from '../../../../components/InternalMenu/Menu'

import Switch from "react-switch"

import { useForm } from "react-hook-form"

import { get, put, deleteItem } from '../../../../services/http'
import { notify } from '../../../../components/Toast'

import { ToastContainer } from 'react-toastify'
import { useNavigate } from 'react-router-dom'

import { useParams } from 'react-router'

import { baseUrl } from '../../../../Data'

export default function index() {
  const navigate = useNavigate()
  const { id } = useParams()

  const [resturants, setResturants] = useState([])
  const [resturant, setResturant] = useState([])
  const [categories, setCategories] = useState([])
  const [categorySelect, setCategorySelect] = useState()
  const [categoryList, setCategoryList] = useState([]) 
  const [category, setCategory] = useState([])
  const [foods, setFoods] = useState([])
  const [pic, setPic] = useState()
  const [clickButton, setClickButton] = useState(false)
  const [foodStatus, setFoodStatus] = useState()

  const [modal, setModal] = useState(false)
  const [cover, setCover] = useState(false)

  const [withPic, setWithPic] = useState(false)

  const token = localStorage.getItem('token')
  
  document.title = 'ایجاد غذا یا نوشیدنی'

  const { register, handleSubmit, reset } = useForm()

  useEffect(() => {
    get(`/api/admin/im/shops?token=${token}`)
      .then(respose => {
        setResturants(respose.data.data.docs)
      }).catch(error => {
        notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      })

    get(`/api/admin/im/categories/all?token=${token}`)
      .then(respose => {
        setCategories(respose.data.data.docs)
      }).catch(error => {
        notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      })

    get(`/api/admin/im/foods/${id}?token=${token}`)
      .then(response => {
        setFoods(response.data.data[0])
        setCategory(response.data.data[0].category[0])
        setResturant(response.data.data[0].shop[0])
        setFoodStatus(response.data.data[0].status)

        let defaultValues = {}
        defaultValues.name = response.data.data[0].name
        defaultValues.price = response.data.data[0].price
        defaultValues.level = response.data.data[0].level
        defaultValues.discountPrice = response.data.data[0].discountPrice
        defaultValues.description = response.data.data[0].description

        reset({ ...defaultValues })
      }).catch(error => {
        notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      })
  }, [id, reset, token])

  const onSubmit = (data, e) => {
    e.preventDefault()
    setClickButton(true)

    let formData = new FormData()

    const config = {
      headers: {
        'content-type': 'multipart/form-data'
      }
    } 

    if (withPic) {
      formData.append('pic', pic)
      formData.append('shop', data.shop)
      formData.append('category', data.category)
      formData.append('name', data.name)
      formData.append('price', data.price)
      formData.append('discountPrice', data.discountPrice)
      formData.append('level', data.level)
      formData.append('description', data.description)

      put(`/api/admin/im/foods/${id}?token=${token}`, formData, config)
        .then(response => {
          notify('success', response.data.messageFa)
          setTimeout(() => {
            navigate('/im/foods')
          }, 2000)
        }).catch(error => {
          setClickButton(false)
          if (error) {
            notify('error', error)
          }
          notify('error', 'خطا در ارسال اطلاعات')
        })
    } else {
      const dataForm = {
        shop: data.shop,
        category: data.category,
        name: data.name,
        price: data.price,
        discountPrice: data.discountPrice,
        level: data.level,
        description: data.description
      }
      put(`/api/admin/im/foods/withoutpic/${id}?token=${token}`, dataForm)
        .then(response => {
          notify('success', response.data.messageFa)
          setTimeout(() => {
            navigate('/im/foods')
          }, 2000)
        })
        .catch(error => {
          if (error) {
            notify('error', error)
          }
          notify('error', 'خطا در ارسال اطلاعات')
        })
    }
  }

  const categoryHandler = (e) => {
    setCategorySelect(e.target.value)
    setCategoryList([])
    // eslint-disable-next-line array-callback-return
    categories.map(item => {
      if (item.shop[0]._id === e.target.value) {
        setCategoryList(oldArray => [...oldArray, item])
      }
    })
  }

  const deleteHandler = (e) => {
    deleteItem(`/api/admin/im/foods/${id}?token=${token}`)
      .then(response => {
        setCover(false)
        setModal(false)
        notify('success', response.data.messageFa)
        setTimeout(() => {
          navigate('/im/foods')
        }, 2000)
      })
      .catch(error => {
        if (error) {
          notify('error', error)
        }
        notify('error', 'خطا در ارسال اطلاعات')
      })
  }

  const picHandler = () => {
    setWithPic(true)
  }

  const statusHandler = () => {
    let data = { status: true }
    setFoodStatus(!foodStatus)
    if (foodStatus) {
      data = { status: false }
    } else {
      data = { status: true }
    }
    put(`/api/admin/im/foods/status/${id}?token=${token}`, data)
      .then(response => {
        notify('success', response.data.messageFa)
        setTimeout(() => {
          navigate('/im/foods')
        }, 2000)
      })
      .catch(error => {
        if (error) {
          notify('error', error)
        }
        notify('error', 'خطا در ارسال اطلاعات')
      })
  }

  return (
    <main id='panel'>
      <div className="cover" style={{ display: cover? '': 'none' }}>
      </div>
      <div className='deleteModal' style={{ display: modal? '': 'none' }}>
        <div className="textDeleteModal">
          آیا میخواهید غذا یا نوشیدنی حذف شود؟
        </div>
        <hr />
        <div className="buttons">
          <button onClick={deleteHandler}>حذف شود</button>
          <button onClick={e => {
            setCover(false)
            setModal(false)
          }}>انصراف</button>
        </div>
      </div>
      <ToastContainer rtl />
      <Menu page={'food'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className='right' style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
              <div className='text' >
                <div>
                </div>
                <Switch onChange={statusHandler} 
                  checked={foodStatus ? foodStatus : false} 
                  onColor="#86d3ff"
                  onHandleColor="#2693e6"
                  handleDiameter={30}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                  activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                  height={20}
                  width={48}
                  className="react-switch"
                  id="material-switch"
                  />
              </div>
              <div>
                <button onClick={e => { 
                  setCover(true)
                  setModal(true) }} style={{ backgroundColor: '#ff6666' }} className='createButton' type='submit'> حذف غذا یا نوشیدنی</button>
              </div>
            </div>

            <div className='left'>
            </div>
          </div>

          <form className='form' onSubmit={handleSubmit(onSubmit)}>
            <div className='title'>
              * برای ایجاد غذا و یا نوشیدنی باید فیلد های زیر را پر کنید، برای تصویر غذا یا نوشیدنی از تصویر با کیفیت و نورپردازی شده استفاده کنید، تاثیر زیادی در کیفیت منو شما دارد.
            </div>
            <div className='lineTitleFood'>
              <hr />
              اطلاعات غذا یا نوشیدنی‌
              <hr />
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='foodName'>نام * :</label>
                <input id='foodName' {...register("name", { required: true, minLength: 3 })} type='text' placeholder='مثلا پیتزا' />
                <small id='foodNameAlert'>نام باید وارد شود</small>
              </div>
              <div className='column'>
                <label htmlFor='foodPrice'>قیمت * :</label>
                <input id='foodPrice' {...register("price", { required: true, minLength: 3 })} className='ltrdirection' type='text' placeholder='25...' />
                <small id='foodPriceAlert'>قیمت باید وارد شود</small>
              </div>
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='foodLevele'>اولویت * :</label>
                <input id='foodLeveleDetails' {...register("level", { required: true })} type='number' />
                <small id='foodLeveleDetailsAlert'>اولویت باید وارد شود</small>
              </div>
              <div className='column'>
                <label htmlFor='foodDiscountPrice'>قیمت با تخفیف * :</label>
                <input id='foodDiscountPrice' {...register("discountPrice", { required: true })} className='ltrdirection' type='text' placeholder='24...' />
                <small id='foodDiscountPriceAlert'>قیمت با تحفیف باید وارد شود</small>
              </div>
            </div>
            <div className="row">
              <div className='column'>
                <label htmlFor='resturantName'>انتخاب رستوران * : {resturant ? resturant.name : ''}</label>
                <select id='resturantName' {...register("shop", { 
                  onChange: (e) => {categoryHandler(e)},
                  required: true })}>
                  <option id='none'>انتخاب کنید</option>
                  {resturants ? resturants.map((item, index) => {
                    return <option key={index} value={item._id}>{item.name}</option>
                  }) : ''}
                </select>
                <small id='resturantNameAlert'>رستوران باید انتخاب شود</small>
              </div>
              <div className='column'>
                <label htmlFor='categoryName'>انتخاب دسته بندی * : {category ? category.title : ''}</label>
                <select id='categoryName' {...register("category", { required: true })}>
                  {categoryList ? categoryList.map((item, index) => {
                    return <option key={index} value={item._id}>{item.title}</option>
                  }) : ''}
                </select>
                <small id='categoryNameAlert'>رستوران باید انتخاب شود</small>
              </div>
            </div>
            <div className='row'>
              <div className='column textarea'>
                <label htmlFor='foodDetail'>توضیحات * :</label>
                <textarea id='foodDetail' rows={5} placeholder='توضیحات' {...register("description", { required: true })} />
                <small id='foodDetailAlert'>توضیحات باید وارد شود</small>
              </div>
            </div>
            <div className='lineTitleFood'>
              <hr />
              انتخاب عکس غذا یا نوشیدنی‌
              <hr />
            </div>
            <div className='row' style={{ position: 'relative' }}>
              <div className='column' style={withPic ? {} : { display: 'none' }}>
                <label htmlFor='foodPic'>عکس غذا یا نوشیدنی * :</label>
                <input id='foodPic' type='file'
                  onChange={e => {
                    const fileSelect = e.target.files[0]
                    setPic(fileSelect)
                  }} />
                <small id='foodPicAlert'>عکس باید انتخاب شود</small>
              </div>
              <div className='column' style={withPic ? { display: 'none' } : {}}>
                <img width={'100px'} src={foods ? `${baseUrl.address}${foods.pic}` : ''} alt='logo' />
                <div className='positiveIcon' onClick={picHandler}>+</div>
              </div>
            </div>
            <button className='createButton' type='submit' style={clickButton ? { backgroundColor: 'gray' } : {}} disabled={clickButton ? true : false}>{clickButton ? 'در حال آپلود ...' : 'آپدیت غذا یا نوشیدنی'}</button>
          </form>
          <div className='copyright'>
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}
